import $axios from './requestAxios'
import router from '../router/index'
import { Toast } from 'vant';
import QRCode from 'qrcodejs2'  // 引入qrcode
import { getToken, getAppId } from '@/utils/auth'

export default {
  // 获取当前设备类型
  getUa: () => {
    let ua = window.navigator.userAgent;
    if (ua.match(/MicroMessenger/i) == 'MicroMessenger') {
      return 'wx';
    } else if ((ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) == null) {
      return 'pc';
    } else {
      return 'app';
    }
  },
  // 发送验证码 phone: 手机号
  sendCode: (phone) => {
    $axios({
      method: "POST",
      url: "/sms/send",
      data: {
        phone: phone
      },
      success: data => {

      }
    })
  },
  // 判断验证码是否正确 phone: 手机号,code: 验证码, el: 调用处this,
  verification: (phone, code, el) => {
    if (!/^1[3456789]\d{9}$/.test(phone)) {
      Toast("请输入正确手机号!");
      return;
    };
    if (code.length < 4) {
      Toast("请输入正确验证码!");
      return;
    }
    $axios({
      method: "POST",
      url: "/sms/verification",
      data: {
        phone: phone,
        captcha: code
      },
      success: data => {
        if (data.data.status == 'success') {
          el.codeFlag = phone
        } else {
          Toast('验证码错误')
          el.codeFlag = false
        }
      }
    });
  },
  // 判断两个对象是否相同
  isEqual: (obj1, obj2) => {
    if (!obj1 instanceof Object || !obj2 instanceof Object) { // 判断不是对象
      return obj1 === obj2;
    }
    if (Object.keys(obj1).length !== Object.keys(obj2).length) { //Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,判断键值个数是否相等
      return false;
    }
    for (let attr in obj1) { //逐个值进行判断
      if (obj1[attr] instanceof Object && obj2[attr] instanceof Object) { //如果值为对象再递归进行判断
        return isEqual(obj1[attr], obj2[attr]);
      } else if (obj1[attr] !== obj2[attr]) {
        return false;
      }
    }
    return true;
  },
  // 使用value值获取key
  findKey: (val, data, compare = (a, b) => a === b) => {
    return Object.keys(data).find(k => compare(data[k], val))
  },
  // 使用key值获取value
  findVal: (k, obj) => {
    k += '';
    for (let i in obj) {
      if (i == k)
        return obj[k];
    }
  },
  // 自动登录 url: 域名后的相对路径
  getCpAppConfig: (url) => {
    let pathName = location.pathname;
    let appId = pathName.substr(pathName.lastIndexOf('/') + 1, pathName.length);

    if (getToken() && getAppId() == appId) {
      return;
    }

    let redirect_uri = '';
    if (url) {
      redirect_uri = '&redirect_uri=' + url;
    }
    $axios({
      method: "POST",
      url: "/get/getCpAppConfig",
      data: {
        appId: appId
      },
      success: data => {
        let isGuest = data.data.data.is_guest || 0;
        if (data.data.status == 'success' && isGuest == 1) {
          location.replace(`${process.env.AUTO_LOGIN}?app_id=${data.data.data.app_id}` + redirect_uri)
        } else {
          router.replace('/logOut?type=4');
        }
      }
    });
  },
  // 调出PC微信支付二维码弹窗 url: 二维码链接 callback: 点击未完成和已完成支付除隐藏页面的其它操作
  setWxCode(url, money, callback) {
    // <div class="wx-code" ref="wxqrcode" v-show="false"></div>
    let el;
    let body = document.getElementsByTagName("body")[0];
    let configInfo = JSON.parse(localStorage.getItem('configInfo'));
    let ossUrl = process.env.OSS_DOMAIN;
    callback = callback || (() => { });

    elCreat();

    let wxCode = document.getElementsByClassName('wx-btn');
    let wxClose = document.getElementsByClassName('wx-close');

    for (let i = 0; i < wxCode.length; i++) {
      wxCode[i].addEventListener('click', click, 0);
    };
    wxClose[0].style.display = 'none';
    wxClose[0].addEventListener('click', click, 0);

    let wxqrcode = new QRCode('wxqrcode', {
      width: 132,
      height: 132,
      text: url || '微信提醒您：二维码生成错误。请刷新重试！', // 二维码地址
      colorDark: "#000",
      colorLight: "#fff",
    });

    function click() {
      elRemove();
      callback();
    }

    function elRemove() {
      body.removeChild(el);
    }

    function elCreat() {
      el = document.createElement("div");
      el.className = 'wx-code';
      el.innerHTML =
      `<div class="wx-content" style="
        color: ${configInfo.popup_title_color || ''};
        border-color: ${configInfo.popup_border_color || ''};
        ">
        <p>微信支付</p>
        <p class="title">微信扫码支付</p>
        <div class="code-coutent">
          <p>运费￥${money}</p>
          <div id="wxqrcode"></div>
        </div>
        <div class="btns">
          <span class="wx-btn">
            未支付
          </span>
          <span class="wx-btn" style="
            background-color: #53a3ff;
            background-image: url('${ossUrl+configInfo.popup_buttin_color}');
            color: #fff;">
            支付完成
          </span>
        </div>
        <div class="wx-close"></div>
      </div>`;
      body.appendChild(el);
    }

  },
  goBack() {
    router.go(-1);
  },
  payWx() {

  },
  payZfb() {

  },
  payWxGzh(payConfig) {
    let appId = JSON.parse(localStorage.getItem("configInfo")).app_id;
    let returnUrl = `${location.protocol}//${location.host}/payDialog?app_id=${appId}`;
    if (appId == '10108') {
      location.replace(`${process.env.DEBUG_WX_PAY_API}?appId|${payConfig.appId}&timeStamp|${payConfig.timeStamp}&nonceStr|${payConfig.nonceStr}&package|${payConfig.package}&signType|${payConfig.signType}&paySign|${payConfig.paySign}&returnUrl|${returnUrl}`);
    } else {
      location.replace(`${process.env.WX_PAY_API}?appId|${payConfig.appId}&timeStamp|${payConfig.timeStamp}&nonceStr|${payConfig.nonceStr}&package|${payConfig.package}&signType|${payConfig.signType}&paySign|${payConfig.paySign}&returnUrl|${returnUrl}`);
    }
  },
  getPayType(type) {
    let obj = {
      app: {
        zfb: 0,
        wx: 1,
      },
      pc: {
        zfb: 2,
        wx: 3,
      },
      wx: {
        wx: 4,
      }
    }
    return obj[this.getUa()][type]
  },
  getPos(el) {
    let left = 0, top = 0;
    while (el) {
      top += el.offsetTop;
      left += el.offsetLeft;
      el = el.offsetParent;
    }
    return {left: left, top: top};
  },
  addBodyClassName() {
    if (localStorage.getItem("configInfo")) {
      let uid = JSON.parse(localStorage.getItem("configInfo")).cp_uid;
      let appId = JSON.parse(localStorage.getItem("configInfo")).app_id;
      let bodyClassName = document.body.className
      if (uid == '1218' || uid == '10029') {
        document.body.className = 'csw-app ' + bodyClassName;
      }
    }
  },
  isToday (date) {
    date = date.replace(/-/g, "/")
    return new Date().toString().substr(0, 15) === new Date(date).toString().substr(0, 15)
  }
};



// WEBPACK FOOTER //
// ./src/utils/util.js